<template>
    <div id="whatsapp-v1-channels">
        <AppBreadCrumb :paths="[{ title: $t('whatsappChannel.whatsappTitleV1') }]" :select="true"></AppBreadCrumb>
        <UpgradeNeeded v-if="showUpgrade" @close="showUpgrade = false" @show-plans="showWhatsappPlans">
            <div v-if="maxWhatsappChannel <= 0">
                Whatsapp kanalı oluşturmak için Whatsapp paketi satın almalısınız. Uygun fiyatları paketlere hemen
                ulaşabilirsiniz.
            </div>
            <div v-else>
                Whatsapp kanal oluşturma limitine ulaştınız. Maximun
                <b>{{ maxWhatsappChannel }}</b> Whatsapp Kanalı oluşturabilirsiniz. Devam etmek için paketinizi
                yükseltin yada Whatsapp kanalarınızdan bir kaçını siliniz.
            </div>
        </UpgradeNeeded>

        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">{{ $t("whatsappChannel.whatsappTitleV1") }}</div>
                <div class="channels">
                    <div class="story channel-add" @click="createChannel">
                        <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">
                            {{ $t("whatsappChannel.addChannel") }}
                        </span>
                    </div>
                    <div
                        class="channel-item"
                        :class="[!channel.enabled && 'disabled']"
                        v-for="(channel, index) in channels"
                        @click="() => channel.enabled && editChannel(channel)"
                        :key="index"
                    >
                        <div class="icon-container">
                            <WhatsappIcon />
                        </div>
                        <div class="name-container">
                            <span class="name">{{ channel.name.toUpperCase() }}</span>
                            <span class="phone">
                                ({{ channel.payload.phoneNumber }}) - ({{
                                    channel.forward.story ? "Chatbot" : "Live Agent"
                                }})
                            </span>
                        </div>

                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item>
                                            <!--                                            menü iteminde düzenleye bastığımızda chanel id si çıkıyordu o yüzden bu şekilde kaybolmaması için burda tutuyorum-->
                                            <!--                                            @click="-->
                                            <!--                                            $router.push(-->
                                            <!--                                            `/integrations/whatsapp-business-api/${channel._id}/update`-->
                                            <!--                                            )-->
                                            <div class="icon-container" @click="editShowCreateForm = channel">
                                                <md-icon style="margin-right: 10px">edit</md-icon>
                                                <span>{{ $t("message.edit") }}</span>
                                            </div>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <!--                                            @click="deleteWebhookModal(channel._id)" bu kısım silme kısmı şimdilik bekle bu şekilde -->
                                            <div class="icon-container" @click="deleteMultiWp(channel._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>{{ $t("chatbotv2.delete") }}</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal2
            :title="$t('whatsappChannel.newWhatsappChannel')"
            :description="$t('whatsappChannel.newWhatsappChannelDescription')"
            class-name="new-waba"
            :showFooter="false"
            @cancel="showCreateForm = false"
            v-if="showCreateForm"
        >
            <NewMultiWhatsappChannel @cancel="showCreateForm = false" @ok="channelCreated" />
        </Modal2>
        <Modal2
            :title="$t('whatsappChannel.editWhatsappChannel')"
            :description="$t('whatsappChannel.editWhatsappChannelDescription')"
            class-name="new-waba"
            :showFooter="false"
            @cancel="editShowCreateForm = false"
            v-if="editShowCreateForm"
        >
            <EditMultiWhatsappChannel
                :channel="editShowCreateForm"
                @cancel="editShowCreateForm = false"
                @ok="channelCreated"
            />
        </Modal2>
        <a-modal
            :visible="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import InstagramIcon from "../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import WebhookIcon from "../Chatbot/pages/integrations/svg/WebhookIcon.vue";
import SkypeIcon from "../Chatbot/pages/integrations/svg/SkypeIcon.vue";
import FacebookIcon from "../Chatbot/pages/integrations/svg/FacebookIcon.vue";
import ShopifyIcon from "../../../components/fast-initialize/svg/ShopifyIcon.vue";
import SlackIcon from "../Chatbot/pages/integrations/svg/SlackIcon.vue";
import TwitterIcon from "../Chatbot/pages/integrations/svg/TwitterIcon.vue";
import SupsisIcon from "../Chatbot/pages/integrations/svg/SupsisIcon.vue";
import TelegramIcon from "../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Modal2 from "../../../components/common/Modal2.vue";

import _ from "lodash";
import NewMultiWhatsappChannel from "./NewMultiWhatsappChannel.vue";
import EditMultiWhatsappChannel from "./UpdateDetail.vue";
import Templates from "../Chatbot/pages/templates/Templates.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import UpgradeNeeded from "../../../components/billing/UpgradeNeeded.vue";

export default {
    name: "MultiWhatsappChannels",
    components: {
        Templates,
        NewMultiWhatsappChannel,
        WhatsappIcon,
        TelegramIcon,
        SupsisIcon,
        TwitterIcon,
        SlackIcon,
        ShopifyIcon,
        FacebookIcon,
        SkypeIcon,
        WebhookIcon,
        InstagramIcon,
        Modal2,
        EditMultiWhatsappChannel,
        AppBreadCrumb,
        UpgradeNeeded,
    },
    data() {
        return {
            showCreateForm: false,
            editShowCreateForm: false,
            updatingChannel: null,
            deleteModal: false,
            deleteChannelId: null,
            maxChannelCount: 0,
            showUpgrade: false,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => ["whatsapp-v1", "whatsapp-qr"].includes(x.type)),
            channelCount: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-v2", "whatsapp-v1", "whatsapp-qr"].includes(x.type))
                    .length,
            maxWhatsappChannel: (state) => state.site.features?.maxWhatsappChannel || 0,
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
            deleteChannel: "channel/deleteChannel",
        }),
        deleteMultiWp(channelId) {
            this.deleteModal = true;
            this.deleteChannelId = channelId;
        },
        editChannel(channel) {
            //todo v2
            this.$router.push(`/integrations/whatsapp-v1/${channel._id}/update`);
        },
        createChannel() {
            if (this.channelCount >= this.maxWhatsappChannel) {
                this.showUpgrade = true;
                return;
            }
            this.showCreateForm = true;
        },
        showWhatsappPlans() {
            this.$router.push("/billing/plans/whatsapp");
        },
        channelCreated(channel) {
            //todo v2
            this.showCreateForm = false;
            this.$router.push(`/integrations/whatsapp-v1/${channel._id}/update`);
        },
        deleteWhatsappChannel() {
            this.deleteChannel(this.deleteChannelId).then(() => {
                this.deleteModal = false;
            });
        },
    },
    mounted() {
        this.listChannels();
        this.listStories();
    },
};
</script>

<style lang="scss" scoped>
#whatsapp-v1-channels {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &.disabled {
                opacity: 0.5;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 70px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #58ca64;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px !important;

                .phone {
                    font-size: 14px;
                    font-weight: normal;
                    color: #a4a4a4;
                }
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }
}
</style>
